import { AuthorizedGuard } from './authorized.guard';
import { DevEnvGuard } from './dev-env.guard';
import { NotAuthorizedGuard } from './not-authorized.guard';

export { AuthorizedGuard, DevEnvGuard, NotAuthorizedGuard };

export default [AuthorizedGuard, DevEnvGuard, NotAuthorizedGuard];
